export default "__VITE_ASSET__C0PQ2Ysm__"